module.exports = __webpack_public_path__ + "static/media/upload3.b74b59db.png";